var React = require('react');

function IconChat (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.2492 0H0.750751C0.337838 0 0 0.346154 0 0.769231V14.7077C0 14.9615 0.3003 15.0923 0.48048 14.9077L4.57207 10.7154H14.2492C14.6622 10.7154 15 10.3692 15 9.94615V0.769231C15 0.346154 14.6622 0 14.2492 0Z"}));
}

IconChat.defaultProps = {"viewBox":"0 0 15 15","fill":"none"};

module.exports = IconChat;

IconChat.default = IconChat;
